import { useChart } from "./index";
import { Card, CardHeader } from "@mui/material";
import Chart from "react-apexcharts";
import React from "react";

const SubscriptionsStatisticsChart = ({ subscriptionStatisticData }) => {
  const chartOptions = useChart({
    xaxis: {
      categories: subscriptionStatisticData.resultList?.map(
        (item) => item.columnName
      ),
    },
    yaxis: [
      {
        labels: {
          formatter: function (val) {
            return val.toFixed(0);
          },
        },
      },
    ],
  });

  return (
    <Card style={{ height: "100%" }}>
      <CardHeader
        title="Assinaturas criadas com link de afiliado"
        subheader="O número de assinaturas criadas com o link de afiliado."
      />

      <Chart
        options={chartOptions}
        series={[
          {
            name: "Assinaturas criadas",
            data: subscriptionStatisticData.resultList.map((item) =>
              item.number.toFixed(0)
            ),
          },
        ]}
        type="bar"
        height={300}
      />
    </Card>
  );
};

export default SubscriptionsStatisticsChart;
